import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { NotifyError } from 'src/app/pages/pages.actions';
import { PagesState } from 'src/app/pages/pages.model';
import { validateEmail } from 'src/app/utils';
import { KeyziiService } from 'src/app/wss/keyzii.service';
import { AddUser, DeleteUser } from '../training.actions';
import { TrainingState } from '../training.model';
import { playChanged, user } from '../training.selectors';
import { TrainingService } from '../training.service';



@Component({
  selector: 'train-new-user',
  templateUrl: 'new-user.component.html',
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent {
  @Output() close: EventEmitter<void> = new EventEmitter();
  orig_user_types = [
    { desc: 'Parent or Guardian', val: "parent" },
    // { desc: 'Manager', val: "manager" },
    { desc: 'Care provider', val: "care" }
  ]
  rol_desc: string = "Care provider"
  user_types: any = {}
  bReady: boolean = false
  bEditEmail: boolean = true
  bInvaildEmail: boolean = true
  // send_back: string = "#bbb"
  email: string = ""
  first_name: string = ""
  last_name: string = ""

  _user: any
  rol_index: number = 1
  title: string = "Invite New User"
  btn_lbl: string = "Invite"

  edit_user_id: string | undefined
  @Input() set user_id(id: any) {
    this.edit_user_id = id
    this.setUser()
  }
  @Input() set caller(c: any) {
    if (c && c.email) {
      this.edit_user_id = c._id
      if (c.first_name) {
        this.first_name = c.first_name
      }
      if (c.last_name) {
        this.last_name = c.last_name
      }

      this.email = c.email
      this.changedEmail(this.email)
    }
  }
  bShowDelUser: boolean = false
  _users: any = {}
  patient: any
  @Input() set users(us: any[]) {
    if (us) {
      this._users = us
      this.setUser()
    }
  }
  subscriptions: any[] = []
  constructor(
    public keyzii_service: KeyziiService,
    public pagesState: Store<PagesState>,
    public training_service: TrainingService,
    public trainingStore: Store<TrainingState>,

  ) {

    console.log("add training user")
    this.subscriptions.push(this.pagesState.select(user).subscribe((user: any) => {
      if (user && user.customer_id) {
        this._user = user
        this.setUser()
      }
    }))
    this.subscriptions.push(this.trainingStore.select(playChanged).subscribe((play: any) => {
      console.log("playChanged " + new Date())
      if (play && play._id) {
        this.patient = play
      }
    }))
    this.user_types = Object.assign([], this.orig_user_types)

  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    })
  }
  setUser() {
    if (this.edit_user_id && this._users) {
      let u = this._users[this.edit_user_id]
      if (u) {
        this.bEditEmail = false
        this.title = "Edit User"
        // this.send_back = "#bbb"
        this.btn_lbl = "Save"
        if (u.email) {
          this.email = u.email
          this.changedEmail(this.email)
        }
        if (u.first_name) {
          this.first_name = u.first_name
        }
        if (u.last_name) {
          this.last_name = u.last_name
        }

        if (u.roll) {
          if (u.roll == 'parent') {
            this.rol_index = 0
          } else {
            this.rol_index = 1
          }
        }
        //Now select the options for the filet
        this.user_types = Object.assign([], this.orig_user_types)
        let user_type = Object.assign({}, this.user_types[this.rol_index])
        user_type.selected = true
        this.user_types[this.rol_index] = user_type
        this.rol_desc = this.user_types[this.rol_index].desc

        this.changedEmail(this.email)
        let bShowDelUser = true
        if (this._user && this._user._id == this.edit_user_id) {
          bShowDelUser = false
        }
        if (this.rol_index == 0) {// parent, make sure is not the last parent
          let users_ids = Object.keys(this._users)
          let num_parents = 0
          for (let i = 0; i < users_ids.length; i++) {
            let key = users_ids[i]
            let u = this._users[key]
            if (u.roll == 'parent') {
              num_parents++
            }
          }
          if (num_parents < 2) {
            bShowDelUser = false
          }
        }
        setTimeout(() => this.bShowDelUser = bShowDelUser)
      }
    }
  }

  async invite() {
    console.log("invite")
    if (!this.bReady) {
      return
    }

    let user: any = {
      email: this.email,
      first_name: this.first_name,
      last_name: this.last_name,
      roll: this.orig_user_types[this.rol_index].val,
      patient_first_name: this.patient.first_name,
      patient_last_name: this.patient.last_name,
    }
    if (this.edit_user_id) {
      user._id = this.edit_user_id
    }
    try {
      let new_user = await this.training_service.addUser(user)
      this.trainingStore.dispatch(new AddUser(new_user))
      this.close.emit()
    } catch (e: any) {
      console.error(e)
      // console.error(e)
      let err = "Error"
      if (e.error.error) {
        err = e.error.error
      } else if (e.error) {
        err = e.error
      }
      this.pagesState.dispatch(new NotifyError(err))
    }
    this.cancel()
  }
  async   resetPwd() {
    if (this.edit_user_id) {
      try {
        await this.training_service.resetPwd(this.email, this.first_name, this.last_name)
      } catch (e: any) {
        console.error(e)
      }
      this.close.emit()
    }
  }
  async deleteUser() {
    if (this.edit_user_id) {
      try {
        let del_user = this._users[this.edit_user_id]
        if (del_user) {

          await this.training_service.delUser(del_user)
          this.trainingStore.dispatch(new DeleteUser(this.edit_user_id))
        }
      } catch (e: any) {
        console.error(e)
      }
      this.close.emit()
    }
  }
  cancel() {
    this.close.emit()
  }

  setSelUserType(sel: number) {
    this.user_types = Object.assign([], this.orig_user_types)
    let user_type = Object.assign({}, this.user_types[1])
    user_type.selected = true
    this.user_types[sel] = user_type
  }
  changedEmail($event: any) {
    if ($event) {
      if (validateEmail($event)) {
        this.email = $event
        this.bInvaildEmail = false
      } else {
        this.bInvaildEmail = true
      }
      this.checkReady()
    }
  }
  userRole($event: any[]) {
    for (let i = 0; i < $event.length; i++) {
      let opt = $event[i]
      if (opt.selected) {
        this.rol_index = i
      }
    }
    this.checkReady()
  }
  changedName($event: any) {
    this.checkReady()
  }
  checkReady() {
    this.bReady = (this.first_name.length > 0 && this.last_name.length > 0)
    if (this.bReady && this.bEditEmail) {
      this.bReady = !this.bInvaildEmail
    }
  }
}
